<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JNV1kT/tc-custom/9780765398581.jpg?1737750226595" alt="This image is the cover for the book The Impossible Contract, The Chronicles of Ghadid"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Impossible Contract, The Chronicles of Ghadid
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>The Impossible Contract</i> is the second book in K. A. Doore's high fantasy adventure series the Chronicles of Ghadid, where a determined assassin travels to the heart of the Empire in pursuit of a powerful mark, for fans of Robin Hobb, Sarah J. Maas, and S. A. Chakraborty</b><br/><br/>An assassin’s reputation can mean life or death.<br/><br/>This holds especially true for Thana Basbowen, daughter of the legendary Serpent, who rules over Ghadid’s secret clan of assassins. When a top-tier contract drops in her lap — death orders against foreign ambassador Heru Sametket — Thana seizes the opportunity. <br/><br/> Yet she may be in over her head. Heru wields blasphemous powers against his enemies, and Thana isn’t the only person after his life: even the undead pursue him, leaving behind a trail of horror. Her mission leads her on a journey to the heart of a power-hungry empire, where dangers lurk around every corner. Her only ally is Mo, a determined healer set to protect Ghadid any way she can.<br/><br/> As further occult secrets are unleashed, however, the aftermath of this impossible contract may be more than anyone can handle.<br/><br/>The Chronicles of Ghadid<br/>#1: <i>The Perfect Assassin</i><br/>#2: <i>The Impossible Contract</i><br/>#3: <i>The Unconquered City</i><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        K. A. Doore
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?58ac0354